import { render, staticRenderFns } from "./BlogPostSettingsModal.vue?vue&type=template&id=6a3aca6a&"
import script from "./BlogPostSettingsModal.vue?vue&type=script&lang=js&"
export * from "./BlogPostSettingsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports